/* eslint-disable jira/filename-case */
export const NEXTGEN_BACKLOG_REST_RESOURCE = 'NEXTGEN_BACKLOG_REST';
